import React, { useEffect } from 'react';
import CartManuallyAddPart from "./CartManuallyAddPart"
import ClearCart from "../ClearCart"
import CartList from "./CartList"
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useCartStore } from 'src/hooks/cart';
import FadeInOut from "../../../component/Global/FadeInOut";
import ShowAlert from 'src/component/Global/ShowAlert';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { useProductStore } from 'src/hooks/product';
import Constants from 'src/helper/Constants';
import { useOrderStore } from 'src/hooks/order';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';
import System from 'src/helper/system';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const MyCart = (props) => {
  const [{ CART_DATA, VALIDATE_CART }, { }, { }] = useCartStore();
  const [__check] = useAxiosIndicatorCheck();
  const [{ system_alert_list }, { system_alert_indicator, remove_system_alert_indicator }, { }] = useDOMAttachToSystemStore();
  const [{ productList }, { }, { },] = useProductStore();
  const [{ validate_order_from_server }, { }, { }] = useOrderStore()
  const { ACCOUNTINACTIVE, INTERNALUSER, INVALIDSUPPLIER, RESTRICTEDCOUNTRY, INVALIDITEMPRICE, siteUser: { CORE }, speedBoats: { apacAbbr } } = Constants
  const { translation:t, avUserInfoData: { salesOrg } } = System;

  useEffect(() => {
    VALIDATE_CART && Object.keys(VALIDATE_CART)?.length > 0 && Object.entries(VALIDATE_CART?.validation).map(obj => {
      if (![ACCOUNTINACTIVE, INTERNALUSER, RESTRICTEDCOUNTRY, INVALIDITEMPRICE].includes(obj[0]) && (CART_DATA && Object.entries(CART_DATA)?.length > 0)) {
        system_alert_indicator({
          name: obj[0],
          message: obj[1],
          type: "danger"
        })
        errorDetail({name: obj[0], message: obj[1]})
      }
    })

    validate_order_from_server && Object.keys(validate_order_from_server)?.length > 0 && Object.entries(validate_order_from_server?.validation).map(obj => {
      if (obj[0] === INVALIDSUPPLIER) {
        system_alert_indicator({
          name: obj[0],
          message: obj[1],
          type: "danger"
        })
        errorDetail({name: obj[0], message: obj[1]})
      }
    })

    Object.entries(CART_DATA).map((x, y) => {
      const _product = productList[x[1].ItemNumber]
      if (_product?.ObsoleteFlag || _product?.EndOfLifeFlag) {
        system_alert_indicator({
          name: 'eol/obsolete',
          message: t('thisCartContainsEOLObsoletePart'),
          type: "danger"
        })
        errorDetail({name: 'eol/obsolete', message: t('thisCartContainsEOLObsoletePart')})
      }
      if (_product?.NCNRFlag) {
        system_alert_indicator({
          name: 'NCNRFlag',
          message: t('yourCartContainsNCNR') + ': <span>'+ t('nonCancelableNonReturnableParts') +'</span>',
          type: "warning"
        })
        errorDetail({name: 'NCNRFlag', message: t('yourCartContainsNCNR') + ': <span>'+ t('nonCancelableNonReturnableParts') +'</span>'})
      }
      if (_product?.HazardousFlag) {
        system_alert_indicator({
          name: 'HazardousFlag',
          message: t('hazardousItemsDesc'),
          type: "warning",
          isDisplay: false,
          isDisplayIcon: true
        })
        errorDetail({ name: 'HazardousFlag', message: t('hazardousItemsDesc') })
      }
      if (x[1].isProductAvailableFromMainAPI === false) {
        system_alert_indicator({
          name: 'isProductAvailableFromMainAPI',
          message: t('isProductAvailableFromMianAPIMessage'),
          type: "danger",
          isDisplay: false,
          isDisplayIcon: true
        })
        errorDetail({ name: 'isProductAvailableFromMainAPI', message: t('isProductAvailableFromMianAPIMessage') })
      }

      if (x[1]?.subtotal <= 0 || x[1]?.unitPrice <= 0) {
        let partsWithNoPrice = []
      partsWithNoPrice = Object.entries(CART_DATA).filter((ele) => (ele[1]?.subtotal <= 0 || ele[1]?.unitPrice <= 0)).map((ele) => ele[1]?.erpMfrPartNumber) || null,
        system_alert_indicator({
          name: {INVALIDITEMPRICE},
          message: t('pleaseRemovePart') + ' ' + partsWithNoPrice?.join(', ') + ' ' + t('priceChangeMessage'),
          type: "danger",
        })
      }

    })
  }, [VALIDATE_CART, productList, validate_order_from_server, CART_DATA])

  const errorDetail = ({ name, message}) => {
    let errorInfo = {
      errorName: name,
      errorMessage: message,
      errorLocation: 'cartView'
    }
    // HelperAnalyticsEvent.errorDetail({errorInfo})
  }

  return (
    <>
      {__check(['CHECKOUT_CALL']).status &&
        <AxiosIndicatorRunTimeLoader overlay={true} />}
      <div className="col-xl-9">
        <div className="col-12 m1-3">
          <div className='cart-alert'>
            <ShowAlert />
          </div>

          {(!__check(['CART_API_CALL', 'VIEW_CART_API_CALL']).status) && Object.entries(CART_DATA)?.length === 0 &&
            <>
              <FadeInOut show={true}
                duration={1000} style={{}} className="alert alert-info text-center mb-2">
                <span>{t('yourShoppingCartIsEmpty')}</span>
              </FadeInOut>
            </>
          }
          {System.getCurrentRegionWithType(apacAbbr) ? (
            <FadeInOut show={true}
              duration={1000} style={{}} className="alert alert-info text-center mb-2">
              <span>{t('transactionsInUSDOnly')}</span>
            </FadeInOut>
          ) : (
            <>
              <FadeInOut show={true}
                duration={1000} style={{}} className="alert alert-info text-center mb-2">
                <span>{t('transactionsInJPYOnly')}</span>
              </FadeInOut>
              <FadeInOut show={true}
                duration={1000} style={{}} className="alert alert-info text-center mb-2">
                <span className='text-start'>{t('japanCurrencyMessage')}</span>
              </FadeInOut>
            </>
          )}
        </div>
        <div className="col-auto mt-3">
          <div className="page-title font-oswald font-light font-38 text-uppercase">{t('myCart')}</div>
        </div>
        <CartManuallyAddPart />
        <div className={'pt-2 pb-2'}>
          <ClearCart />
        </div>
        <CartList />

      </div>
    </>
  );
}

export default MyCart;